<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">

		<label>Department</label>
		<select v-model="filters.department_id" @change="getList()">
			<option value="">Select...</option>
			<option v-for="(department, index) in priceOverrideDepartments" :value="department.department_id">{{ department.description }}</option>
		</select>

		<label>Use For</label>
		<select v-model="filters.product_price_override_type_id" @change="getList()">
			<option value="">Select...</option>
			<option v-for="(type, index) in priceOverrideTypes" :value="type.product_price_override_type_id">{{ type.description }}</option>
		</select>

		<label>Flag</label>
		<select v-model="filters.display_flag" @change="getList()">
			<option value="">Select...</option>
			<option v-for="(flag, index) in priceOverrideFlags" :value="index">{{ flag }}</option>
		</select>

		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.has_dates ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('has_dates')"></span>
				<label>Has Dates</label>
			</li>
		</ul>

		<div class="divider"></div>

		<div class="button neutral" @click="clearFilters()">Clear Filters</div>
		<div class="button action" @click="addItem()">Add</div>
		<div :class="['button', gettingExport ? 'disabled' : 'neutral']" @click="doExport()">Export CSV</div>

		<div class="message">{{ exportMessage }}</div>

		<div v-if="legacyLink">
			<div class="divider"></div>
			<router-link :to="legacyLink" class="extra-menu-item">Legacy Version</router-link>
		</div>

	</div>

	<div class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list" width="33"></th>
					<th class="list">Product</th>
					<th class="list">For</th>
					<th class="list">Flag</th>
					<th class="list">Dates</th>
					<th class="list right">Price</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
					<td class="list tiny-image" width="33" align="center"><img :src="item.image_src"></td>
					<td class="list">{{ item.description }}<div class="meta"><label>UPC</label> {{ item.upc}}</div></td>
					<td class="list">{{ $caplitalizeWords(item.product_price_override_type_code) }}</td>
					<td class="list">{{ priceOverrideFlags[item.display_flag] }}</td>
					<td class="list">{{ $formatDate(item.start_date) }}<br>{{ $formatDate(item.end_date) }}</td>
					<td class="list right">{{ item.price }}</td>
				</tr>
			</tbody>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<price-override-detail v-if="showDetail" :listDetail="listDetail" :priceOverrideTypes="priceOverrideTypes" :priceOverrideFlags="priceOverrideFlags" @backToList="backToList" />

	<product-search v-if="searchProducts" singleProduct="true" @assignProduct="assignProduct" @cancel="searchProducts = false" />

	<help-popup :helpLink="{170:'Price Overrides', 369:'Promo Pack Price Overrides', 151:'Inventory Price Overrides' }" :tours="false"></help-popup>


</div>

</template>

<script>
import Loading from '@/components/Loading.vue'
import NumberInput from '@/components/NumberInput.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import ProductSearch from '@/components/ProductSearch.vue'
import PriceOverrideDetail from '@/components/PriceOverrideDetail.vue'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'price-overrrides',
    components: {
        'loading': Loading,
		'number-input': NumberInput,
		'label-required': LabelRequired,
		'product-search': ProductSearch,
		'price-override-detail': PriceOverrideDetail,
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			filters: {},
			filterMessage: '',
			priceOverrideDepartments: [],
			priceOverrideTypes: [],
			priceOverrideFlags: [],
			list: [],
			paging: {},
			showDetail: false,
			listDetail: {},
			gettingExport: false,
			exporting: false,
			exportMessage: '',
			searchProducts: false,
			legacyLink: ''
		}
	},
	created() {
		this.getControlLists()
		this.clearFilters()
	},
	methods: {
		getControlLists() {
			this.apiCall({ destination: 'get_price_override_control_lists' }).then(obj => {
				this.priceOverrideDepartments = obj.price_override_departments
				this.priceOverrideTypes = obj.price_override_types
				this.priceOverrideFlags = obj.price_override_flags
			}).catch(err => {
				console.log(err)
			})
		},
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				department_id: '',
				product_price_override_type_id: '',
				display_flag: '',
				has_dates: 0,
				do_export: 0
			}
			this.getList()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_list_price_overrides', data: this.filters }).then(obj => {
				this.loading = false
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
					if (obj.paging) {
						this.paging = obj.paging
					}
					if (obj.legacy_link) {
						this.legacyLink = obj.legacy_link
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		getItem(item) {
			// NOTE: this will typically be an api action
			this.saveMessage = ''
			this.saving = false
			this.confirmDelete = false
			this.listDetail = item
			this.showDetail = true
		},
		addItem() {
			this.showDetail = false,
			this.listDetail = {}
			this.searchProducts = true
		},
		assignProduct(product) {
			this.searchProducts = false
			product.price = ''
			product.display_flag = 0
			product.product_price_override_type_id = ''
			this.listDetail = JSON.parse(JSON.stringify(product))
			this.showDetail = true
		},
		backToList(updateRequired) {
			this.listDetail = {}
			this.searchProducts = false
			this.showDetail = false
			this.saving = false
			this.searching = false
			this.confirmDelete = false
			this.saveMessage = ''
			this.searchMessage = ''
			if (updateRequired) {
				this.getList()
			}
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList()
		}
	}
}
</script>
